import { AiOutlineLinkedin } from "react-icons/ai";
import { IoLogoGithub } from "react-icons/io5";
import { LuMailPlus } from "react-icons/lu";
import { SlFire } from "react-icons/sl";
import { ActionIcon, Group} from "@mantine/core";

export function LinkIconBar() {
  return (
    <Group justify="center" gap="lg" >
      <ActionIcon
          component="a"
          href="https://www.linkedin.com/in/eliasbelz/"
          target="_blank"
          size="xl">
        <AiOutlineLinkedin size={"95%"}/>
      </ActionIcon>
      <ActionIcon
          component="a"
          href="https://github.com/EliasBelz"
          target="_blank"
          size="xl">
        <IoLogoGithub size={"95%"}/>
      </ActionIcon>
      <ActionIcon
          component="a"
          href="mailto:ebelz@cs.washington.edu"
          target="_blank"
          size="xl">
        <LuMailPlus size={"95%"} />
      </ActionIcon>
      <ActionIcon
          component="a"
          href="https://flowcv.com/resume/8gga26skr9"
          target="_blank"
          size="xl">
        <SlFire size={"95%"} />
      </ActionIcon>
    </Group>
  );
}